import {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {Modal, ModalTitle, ModalText, Button} from '../common/ui';
import commonCss from '../common/common.module.css';
import css from './create.module.css';

interface Props {
  open: boolean;
  onClose: () => void;
  /** Returns true when the note was created (closes the modal). */
  onSubmit: (url: string) => Promise<boolean>;
}

export function YoutubeModal({open, onClose, onSubmit}: Props) {
  const {t} = useTranslation();
  const [url, setUrl] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open) {
      setUrl('');
      setLoading(false);
    }
  }, [open]);

  const submit = async () => {
    if (!url.trim() || loading) {
      return;
    }
    setLoading(true);
    try {
      await onSubmit(url);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal open={open} onClose={loading ? () => {} : onClose}>
      <ModalTitle>{t('YouTube Video')}</ModalTitle>
      <ModalText>{t('SummarizeYouTubeVideo')}</ModalText>
      <input
        className={commonCss.input}
        placeholder={t('PasteLinkHere')}
        value={url}
        onChange={e => setUrl(e.target.value)}
        onKeyDown={e => {
          if (e.key === 'Enter') {
            void submit();
          }
        }}
        autoFocus
        disabled={loading}
      />
      <div className={css.youtubeRow}>
        <Button variant="ghost" onClick={onClose} disabled={loading}>
          {t('Cancel')}
        </Button>
        <Button
          variant="primary"
          icon="youtube"
          onClick={submit}
          loading={loading}
          style={{flex: 1}}
        >
          {t('Summarize')}
        </Button>
      </div>
    </Modal>
  );
}
